var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleCheck(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.22629 17.2504C13.7825 17.2504 17.476 13.5569 17.476 9.00071C17.476 4.44451 13.7825 0.750977 9.22629 0.750977C4.67009 0.750977 0.976562 4.44451 0.976562 9.00071C0.976562 13.5569 4.67009 17.2504 9.22629 17.2504Z",
    stroke: "#277154",
    style: (_ref2 = {
      stroke: "#277154"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1529 0.4431 0.3294)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.2375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33984 9.4134L7.98979 11.0633L12.1147 6.93848",
    stroke: "#277154",
    style: (_ref3 = {
      stroke: "#277154"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1529 0.4431 0.3294)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.2375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle_check.b8f4b06a.svg";
export { ForwardRef as ReactComponent };